import { ActionTypes } from '../constants/index';

export const fetchTopCardsDetail = (payload: any) => ({
  type: ActionTypes.TOP_CARDS_REQUEST,
  payload: {
    startDate: payload.startDate,
    endDate: payload.endDate}
});